import { faqItems } from "@/mocks/homeData";

export default function FaqSection() {
  return (
    <section id="faq" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            常见问答
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            关于6080影视的常见问题，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden"
            >
              <div className="px-5 py-4 md:px-6">
                <h3 className="text-sm font-semibold text-foreground-950 flex items-start gap-3">
                  <span className="text-primary-500 font-bold shrink-0">Q</span>
                  <span>{item.question}</span>
                </h3>
                <div className="mt-2 flex items-start gap-3">
                  <span className="text-accent-500 font-bold shrink-0">A</span>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}